<template>
  <hp-component @openmodal="showModal" v-if="branchesLoaded"></hp-component>
  <MainModal v-if="show" @close="closeModal" class="modal-main">
    <div class="logo-and-title">
      <router-link to="/"
        ><img src="./assets/moje-fitko-logo.svg" class="logo"
      /></router-link>
      <h2 class="main-window-heading">{{ $t('common.reservation_app') }}</h2>
    </div>
  </MainModal>
</template>

<script setup>
import MainModal from "@/components/MainModal.vue";
import { RouterLink } from "vue-router";
import HpComponent from "@/components/HpComponent.vue";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { useBranchesStore } from "@/stores/branches";

const { loadBranches } = useBranchesStore();
const branchesLoaded = ref(false);

const router = useRouter();

onMounted(async () => {
  await loadBranches();
  branchesLoaded.value = true;
});

const show = ref(false);

const showModal = () => {
  show.value = true;
  document.getElementsByTagName("body")[0].style.overflow = "hidden";
  document.querySelector(".app-container")?.classList?.add("zindexed");
};

const closeModal = () => {
  show.value = false;
  document.getElementsByTagName("body")[0].style.overflow = "visible";
  router.push({ path: "/" });
  document.querySelector(".app-container")?.classList?.remove("zindexed");
};

router.afterEach((to) => {
  if (to.path !== "/") {
    showModal();
  }
});
</script>

<style>
.zindexed {
  z-index: 9999999 !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.mb-1 {
  margin-bottom: 1em;
}

.mr-1 {
  margin-right: 1em;
}

.mr-0-5 {
  margin-right: 0.5em;
}

.mb-2 {
  margin-bottom: 2em;
}

.mb-3 {
  margin-bottom: 3em;
}

.mt-1 {
  margin-top: 1em;
}

.mt-2 {
  margin-top: 2em;
}

.mt-3 {
  margin-top: 3em;
}
.logo-and-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.logo {
  max-width: 200px;
  margin-right: 25px;
  min-width: 200px;
}

.swal2-title {
  font-size: 1.85em !important;
}

.dp__theme_light {
  --dp-primary-color: #c39700 !important;
}

.swal2-confirm {
  background-color: #c39700 !important;
}

.swal2-confirm:focus {
  box-shadow: 0 0 0 3px rgba(195, 151, 0, 0.5) !important;
}
</style>

<style scoped>
.modal-main :deep(a) {
  text-decoration: underline;
  color: black;
}

.modal-main :deep(a:hover) {
  color: #eac33d;
  text-decoration: underline;
}

.main-window-heading {
  font-size: 35px;
  color: white;

  @media screen and (max-width: 800px) {
    display: none;
  }
}
</style>
